import classes from './cppErrCard.scss';
import { Link } from "react-router-dom";

const CppErrCard = (props) => {
  let warningImg = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Warning.svg';
  let RefreshImg = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Refresh.svg';
  const formResubmitJSX = <div className={classes.group2}>
                            <div className={classes.notificationLabel}>{'Something went wrong on our end.'}</div>
                            <div className={classes.somethingWrong}><a href="javascript::void(0)" onClick={props.onFormhandler}>Click here to resubmit</a></div>
                        </div>;
  const formErrorJSX = <div className={[classes.notificationLabel, classes.notificationLabelPadding].join(' ')}>
                        <span>{'You must add at least one contact for notifications.'}</span>
                     </div>;
  const errorTypeToShow = props.isFormSubmitError? formErrorJSX : formResubmitJSX;
  return (
    <div className={classes.errorBanner}>
      <div className={classes.errorMessageContainer}>
        <div className={classes.errorMessage}>
          <p className={classes.errorImage}><img src={warningImg} alt="Warning Image" /></p>
            {errorTypeToShow}
        </div>
      </div>
    </div>
  );
};

export default CppErrCard;